import routerOptions0 from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.4.1_@types+node@20.14.2_db0@0.3.2_encoding@0.1.13_eslint@8.35.0_qhy4nvb3enfonziow46a3osdqm/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}